import { useToastContext } from "components/alert/ToastContext";
import { Label } from "components/input/Label";
import { DocumentoPasta } from "model/documentos/DocumentoPasta";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { useLoadingContext } from "provider/LoadingProvider";
import { useEffect, useState } from "react";
import DocumentoPastaService from "service/documentos/DocumentoPastaService";

type Props = {
    visible: boolean;
    onHide: () => void;
    pasta: DocumentoPasta
    onConfirm: () => void;
}

const documentoPastaService = new DocumentoPastaService();
export default function ModalDocumentoPastaEditar(props: Props) {
    const [pasta, setPasta] = useState<DocumentoPasta>(props.pasta);

    const { startLoading, stopLoading } = useLoadingContext();
    const { msgErro, msgAlerta } = useToastContext();

    function handleConfirm() {
        if(!pasta.nome || pasta.nome.trim() === '') {
            msgAlerta("Erro", "O nome da pasta não pode ser vazio.");
            return;
        }

        startLoading();
        let pastaLocal = { ...pasta };
        if (pastaLocal.pastaMae && pastaLocal.pastaMae.id === 0) {
            pastaLocal.pastaMae = null; // Se a pasta mãe for a raiz, não atribui
        }
        documentoPastaService.atualizar(pastaLocal).then(() => {
            stopLoading();
            props.onConfirm();
            props.onHide();
        }).catch((error) => {
            stopLoading();
            msgErro("Erro ao editar", error?.data?.message || "Erro ao editar pasta");
            console.error("Erro ao criar pasta:", error);
        });

    }

    useEffect(() => {
        if (!props.pasta.pastaMae) {
            setPasta({ ...pasta, pastaMae: new DocumentoPasta(0, '(Raiz)', null) });
        }
    }, [])

    return (
        <Dialog
            header="Editar Pasta"
            visible={props.visible}
            baseZIndex={100}
            style={{ width: '500px' }}
            onHide={props.onHide}
            footer={<>
                <Button label="Cancelar" icon="pi pi-times" className="p-button-danger" onClick={props.onHide} />
                <Button label="Editar" icon="pi pi-check" onClick={handleConfirm} />
            </>}
        >
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <Label>Nome</Label>
                <InputText
                    value={pasta.nome}
                    onChange={(e) => setPasta({ ...pasta, nome: e.target.value })}
                />
            </div>

        </Dialog>
    );
}